









import { Component, Prop, Vue } from 'vue-property-decorator';

export enum IconEnum {
  checkSquared = 'icon-check_squared',
  closeSquared = 'icon-close_squared',
  Abandonment = 'icon-levelup_icon_abandonment',
  Add = 'icon-levelup-icon-add',
  AddCircle = 'icon-levelup-icon-add-product',
  ArrowDown = 'icon-levelup_icon_mini_arrow_down',
  ArrowLeft = 'icon-levelup_icon_mini_arrow_left',
  ArrowRight = 'icon-levelup_icon_mini_arrow_right',
  Backoffice = 'icon-levelup-icon-backoffice',
  Bank = 'icon-levelup-icon-bank',
  Billing = 'icon-levelup-icon-billing',
  Budget = 'icon-levelup-icon-budget',
  Certificate = 'icon-levelup_icon_certificate',
  ChangeCall = 'icon-levelup_icon_change_call',
  Clock = 'icon-levelup-icon-clock',
  Close = 'icon-levelup_icon_search_close',
  Comment = 'icon-levelup_icon_comment',
  CompleteArrowDown = 'icon-levelup-icon-complete-arrow',
  CreditCard = 'icon-levelup-icon-credit-card',
  DateCalendar = 'icon-levelup-icon-date',
  DeliveryNote = 'icon-levelup-icon-delivery-note',
  Diploma = 'icon-levelup_icon_diploma',
  Email = 'icon-levelup_icon_email',
  FeeIncidence = 'icon-levelup-icon-fee-incidence',
  Frame = 'icon-levelup_frame',
  Hidden = 'icon-convocation-hidden',
  IconPreview = 'icon-icon-preview',
  Invoice = 'icon-levelup-icon-ivoice',
  MainList = 'icon-levelup_icon_mainlist',
  Marker = 'icon-levelup-icon-marker',
  MenuClients = 'icon-levelup_icon_menu_clients',
  MenuConvocation = 'icon-levelup_icon_menu_convocation',
  MenuIcon = 'icon-levelup_icon_menu',
  MenuProducts = 'icon-levelup_icon_menu_products',
  MenuSettings = 'icon-levelup_icon_menu_settings',
  MenuStaff = 'icon-levelup_icon_menu_staff',
  MenuSync = 'icon-levelup_icon_menu_sync',
  Merchandising = 'icon-levelup_icon_merchandising',
  Participant = 'icon-levelup-icon-participant',
  PdfFile = 'icon-pdf-file',
  Percentage = 'icon-percentage',
  Phone = 'icon-levelup_icon_phone',
  Postpone = 'icon-levelup_icon_postpone',
  Present = 'icon-levelup-icon-present',
  Price = 'icon-levelup-icon-price',
  Provider = 'icon-levelup-icon-provider',
  Reconfirm = 'icon-levelup_icon_reconfirm',
  Repeater = 'icon-levelup_icon_repeater',
  Search = 'icon-levelup_icon_search',
  Seat = 'icon-levelup_icon_seat',
  ShoppingCart = 'icon-levelup-icon-shopping-cart',
  SubstractCircle = 'icon-levelup-icon-subtract-product',
  TargetClient = 'icon-levelup-icon-target-client',
  Tick = 'icon-levelup-icon-tick',
  Ticket = 'icon-levelup_icon_ticket',
  TopLevelPack = 'icon-levelup_icon_tlp',
  PowerPack = 'icon-levelup_icon_pwp',
  WaitingList = 'icon-levelup_icon_waitinglist',
  WhatsApp = 'icon-levelup_icon_whatsapp',
  InfoFill = 'icon-info-fill',
}

@Component
export default class Icon extends Vue {
  @Prop({ default: IconEnum.Seat }) private iconClass!: IconEnum;
  @Prop({ default: false }) private disabled!: boolean;
  @Prop({ default: true }) private stopPropagation!: boolean;

  private handleClick(event: any) {
    if (event && this.stopPropagation) {
      event.stopPropagation();
    }
    if (!this.disabled) {
      this.$emit('icon-click', event);
    }
  }

  private handleMouseenter() {
    this.$emit('mouseenter');
  }

  private handleMouseleave() {
    this.$emit('mouseleave');
  }
}
